module.exports = __webpack_public_path__ + "static/media/portfolio_title_5.d7ae8c92.svg";